import angular from 'angular';
import template from './nalaz.html';
import {NalazController} from './nalaz.controller.js';

const NalazComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: NalazController,
    controllerAs: 'vm'
};

export {NalazComponent};



// WEBPACK FOOTER //
// ./app/components/nalaz/nalaz.component.js